export function storageSupported() {
  let isStorageSupported = false;

  try {
    isStorageSupported = (window.localStorage && true);
  } catch (e) {}

  return isStorageSupported
}